(() => {
  if (!document.body.classList.contains('template-index')) return;
  const tablet = matchMedia('(min-width: 768px) and (max-width: 1023px)');
  const compactDesktop = matchMedia('(min-width: 1024px) and (max-width: 1299px)');
  const originals = new WeakMap();
  function sync() {
    const visibleCount = tablet.matches ? 3 : compactDesktop.matches ? 4 : null;
    document.querySelectorAll('main :is([data-ui-component="Product Lists Section"],[data-ui-component="Collection List Section"]) ecx-carousel[data-enable="true"]').forEach(carousel => {
      if (!originals.has(carousel)) {
        originals.set(carousel, {
          desktopCount: carousel.desktopThumbItemCount,
          mobileCount: carousel.mobileThumbItemCount,
          buttons: Array.from(carousel.querySelectorAll('.js-carousel-prev-btn,.js-carousel-next-btn')).map(button => ({button, step: button.getAttribute('data-step')}))
        });
      }
      const original = originals.get(carousel);
      original.buttons.forEach(({button, step}) => {
        if (visibleCount) button.setAttribute('data-step', String(visibleCount));
        else if (step === null) button.removeAttribute('data-step');
        else button.setAttribute('data-step', step);
      });
      // Keep the native Electro progress indicator aligned with the visible cards.
      carousel.desktopThumbItemCount = visibleCount ?? original.desktopCount;
      carousel.mobileThumbItemCount = visibleCount ?? original.mobileCount;
      carousel.updateScrollIndicator?.();
    });
  }
  customElements.whenDefined('ecx-carousel').then(sync);
  tablet.addEventListener('change', sync);
  compactDesktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
